export type AuthType = 'signin' | 'signup';

export const langs = {
  signin: {
    type: 'Вход',
    password: 'Введите пароль',
    existence_question: 'Еще нет аккаунта?',
    main_action: 'Войти',
    alternative_action: 'Регистрация',
  },
  signup: {
    type: 'Регистрация',
    password: 'Придумайте пароль',
    existence_question: 'Уже есть аккаунт?',
    main_action: 'Создать аккаунт',
    alternative_action: 'Войти',
  },
};
